const initQuickNav = () => {
  $(document).on('click', 'button[data-quick-nav=""]', (event) => {
    const targetSelector = $(event.target).data('target');
    $(targetSelector)[0].scrollIntoView({ behavior: 'smooth' })
  });
}

const initHide = () => {
  const buttonSelector = 'button[data-hide-button]';
  $(document).on('click', buttonSelector, (event) => {
    let element = $(event.target);

    while (!element.is(buttonSelector) && element.closest(buttonSelector).length > 0)
      element = element.parent();

    const targetSelector = element.data('target');
    element.toggleClass('toggled');
    $(targetSelector).toggleClass("hidden");
  });
}

export { initQuickNav, initHide };
